export const createBlueDotSvg = (): SVGSVGElement => {
    const blueDotSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    blueDotSvg.setAttribute('width', '16');
    blueDotSvg.setAttribute('height', '16');
    blueDotSvg.setAttribute('viewBox', '0 0 16 16');
    const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    circle.setAttribute('cx', '8');
    circle.setAttribute('cy', '8');
    circle.setAttribute('r', '8');
    circle.setAttribute('fill', '#4285F4');
    circle.setAttribute('stroke', '#fff');
    circle.setAttribute('stroke-width', '2');
    blueDotSvg.appendChild(circle);
    return blueDotSvg;
}

export const createTargetSvg = (): SVGSVGElement => {
    // Create the SVG element
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', '24');
    svg.setAttribute('height', '24');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor'); // Inherits button color
    svg.setAttribute('stroke2-width', '2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');

    // Vertical line (split to create central gap)
    const line1Top = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line1Top.setAttribute('x1', '12');
    line1Top.setAttribute('y1', '2');
    line1Top.setAttribute('x2', '12');
    line1Top.setAttribute('y2', '9');

    const line1Bottom = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line1Bottom.setAttribute('x1', '12');
    line1Bottom.setAttribute('y1', '15');
    line1Bottom.setAttribute('x2', '12');
    line1Bottom.setAttribute('y2', '22');

    // Horizontal line (split to create central gap)
    const line2Left = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line2Left.setAttribute('x1', '2');
    line2Left.setAttribute('y1', '12');
    line2Left.setAttribute('x2', '9');
    line2Left.setAttribute('y2', '12');

    const line2Right = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line2Right.setAttribute('x1', '15');
    line2Right.setAttribute('y1', '12');
    line2Right.setAttribute('x2', '22');
    line2Right.setAttribute('y2', '12');

    // Outer arcs (small markers at the edges)
    const arcTop = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    arcTop.setAttribute('d', 'M12 2v2');

    const arcBottom = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    arcBottom.setAttribute('d', 'M12 22v-2');

    const arcLeft = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    arcLeft.setAttribute('d', 'M2 12h2');

    const arcRight = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    arcRight.setAttribute('d', 'M22 12h-2');

    // Circle around the crosshair
    const outerCircle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    outerCircle.setAttribute('cx', '12');
    outerCircle.setAttribute('cy', '12');
    outerCircle.setAttribute('r', '10'); // Radius to fit within 24x24 viewBox
    outerCircle.setAttribute('fill', 'none');
    outerCircle.setAttribute('stroke', '#333');
    outerCircle.setAttribute('stroke-width', '2');

    // Append SVG elements
    svg.appendChild(outerCircle); // Add circle first to ensure lines appear on top
    svg.appendChild(line1Top);
    svg.appendChild(line1Bottom);
    svg.appendChild(line2Left);
    svg.appendChild(line2Right);
    svg.appendChild(arcTop);
    svg.appendChild(arcBottom);
    svg.appendChild(arcLeft);
    svg.appendChild(arcRight);
    return svg;
}